import React from "react";
import { Navigate } from "react-router-dom";
import { useSelector } from "react-redux";

const PermissionRoute = ({ children, permission }) => {
  const permissions = useSelector((state) => state.auth.permissions || []);
  const allowed = Array.isArray(permission)
    ? permission.some((item) => permissions.includes(item))
    : permissions.includes(permission);

  return allowed ? (
    children
  ) : (
    <Navigate to="/unauthorized" replace />
  );
};

export default PermissionRoute;
